import { DatePicker, Table, TableColumn, Select, Option, Loading, MessageBox, Notification, Message, Dropdown, DropdownItem, DropdownMenu } from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import lang from 'element-ui/lib/locale/lang/en'
import locale from 'element-ui/lib/locale'

const ElementUIComponents = {
  install (Vue) {
    locale.use(lang)

    Vue.component('el-table', Table)
    Vue.component('el-table-column', TableColumn)
    Vue.component('el-select', Select)
    Vue.component('el-option', Option)
    Vue.component('el-date-picker', DatePicker)
    Vue.component('el-dropdown', Dropdown)
    Vue.component('el-dropdown-menu', DropdownMenu)
    Vue.component('el-dropdown-item', DropdownItem)

    Vue.prototype.$loading = Loading.service
    Vue.prototype.$msgbox = MessageBox
    Vue.prototype.$alert = MessageBox.alert
    Vue.prototype.$confirm = MessageBox.confirm
    Vue.prototype.$prompt = MessageBox.prompt
    Vue.prototype.$notify = Notification
    Vue.prototype.$message = Message
  }
}

export default ElementUIComponents
